/*
  Api End-Point
*/

const HOST_NAME = process.env.config.HOSTNAME
// const PAYMENT = process.env.config.PAYMENT
const VERSION_API = 'api/v1.0'
export const S3shortUrl = 'https://s3.deknerd.com/'

// export const PAYMENT_PAYFORU_DEKNERD = `https://payment.deknerd.com/${VERSION_API}/payForU/buy`
export const PAYMENT_PAYFORU_DEKNERD = `https://payment.deknerd.com/${VERSION_API}/payForU/buyMain`
export const PAYMENT_PAYFORU = `https://test.payforu.com/webservice/payforuservice.svc/paymentapirequest `
export const SOCKET_URL = 'https://socket.deknerd.com'
export const SOCKET_CHAT_URL = 'https://socket.deknerd.com/deknerd'
export const CHAT_HISTORY = id => `https://socket.deknerd.com:8091/api/v1.0/socket/historychat/${id}`
export const CHECK_PAYMENT_STATUS = `${HOST_NAME}/${VERSION_API}/payment/check/payforu`
export const PAYMENT_PAYFORU_MAINPAGE_DEKNERD = `https://payment.deknerd.com/${VERSION_API}/payForU/buyMain`
export const PAYMENT_PAYFORU_OPTION_DEKNERD = `https://payment.deknerd.com/${VERSION_API}/tutor/payment`
export const CHECK_TUTOR_PAYMENT_STATUS = `${HOST_NAME}/${VERSION_API}/tutor/payment/detail`
export const LINE_MESSAGE_EP = `https://utility.deknerd.com/api/v1.0/linebot/sendMessageTutor`

export const LOGIN_EP = `${HOST_NAME}/${VERSION_API}/login`
export const LOGIN_FB_EP = `${HOST_NAME}/${VERSION_API}/login/facebook`
export const LOGIN_GG_EP = `${HOST_NAME}/${VERSION_API}/login/google`
export const LOGOUT_EP = `${HOST_NAME}/${VERSION_API}/logout`

export const REGISTER_FORM_EP = `${HOST_NAME}/${VERSION_API}/register`
export const REGISTER_TUTOR_FORM_EP = `${HOST_NAME}/${VERSION_API}/tutor`
export const TUTOR_EP = slugName => `${HOST_NAME}/${VERSION_API}/tutor/${slugName}`

export const HOME_SIDE_EP = (levelId, categoryId) => `${HOST_NAME}/${VERSION_API}/course/${levelId}/${categoryId}`
// export const HOME_SIDE_EP = (levelId, categoryId) => `http://202.6.18.85:3201/api/v1.0/course/${levelId}/${categoryId}`
// export const HOME_SIDE_EP = (levelId, categoryId) => `https://cache.deknerd.com/api/v1.0/course/${levelId}/${categoryId}`
export const HOME_ALL_EP = (levelId, categoryId, page) => `${HOST_NAME}/${VERSION_API}/product/list/course/${levelId}/${categoryId}/publishDate/${page}/18`
export const COURSE_ALL_EP = (levelId, categoryId, page, num) => `${HOST_NAME}/${VERSION_API}/product/list/course/${levelId}/${categoryId}/name/${page}/${num}`
export const EXAM_ALL_EP = (levelId, categoryId, page) => `${HOST_NAME}/${VERSION_API}/product/list/exam/${levelId}/${categoryId}/publishDate/${page}/18`
export const BANNER_CREATOR = categoryId => `${HOST_NAME}/${VERSION_API}/groupcreator/${categoryId}`
export const REGISTER_FORM_STUDENT = `${HOST_NAME}/${VERSION_API}/student/web`

export const INFO_EP = `${HOST_NAME}/${VERSION_API}/info`
export const SAVE_INFO_DATA_EP = `${HOST_NAME}/${VERSION_API}/customer`
export const CHANGE_PASSWORD_EP = `${HOST_NAME}/${VERSION_API}/customer/editpassword`
export const UPLOAD_PROFILE_IMG = `${HOST_NAME}/${VERSION_API}/customer/image`

export const COURSE_EP = slugName => `${HOST_NAME}/${VERSION_API}/product/${slugName}`
export const EDIT_COURSE_EP = `${HOST_NAME}/${VERSION_API}/product/courses`
export const ADD_WISHLIST_COURSE_EP = id => `${HOST_NAME}/${VERSION_API}/product/wishList/${id}`
export const COURSE_REVIEWS_EP = id => `${HOST_NAME}/${VERSION_API}/product/review/${id}`
export const COURSE_RELATED_EP = id => `${HOST_NAME}/${VERSION_API}/product/related/${id}`
export const REVIEW_EP = `${HOST_NAME}/${VERSION_API}/product/review/`
// export const PAYMENT_EP = `${HOST_NAME}/${VERSION_API}/payForU/buy`
export const PAYMENT_EP = `${HOST_NAME}/${VERSION_API}/product/buy`
// export const PAYMENT_PAYFORU = `${HOST_NAME}/${VERSION_API}/payForU/buy`
export const PRICE_LIST_EP = `${HOST_NAME}/${VERSION_API}/product/money`

export const PROFILE_CARD = id => `${HOST_NAME}/${VERSION_API}/creator/${id}`
export const PROFILE_CARD_EP = creatorSlugName => `${HOST_NAME}/${VERSION_API}/creator/${creatorSlugName}`
export const CREATOR_COURSE_EP = creatorSlugName => `${HOST_NAME}/${VERSION_API}/creator/product/${creatorSlugName}`
export const CHANGE_FOLLOW_EP = id => `${HOST_NAME}/${VERSION_API}/creator/following/${id}`

export const ALL_CREATOR_EP = (level, category, type, page) => `${HOST_NAME}/${VERSION_API}/creator/list/${level}/${category}/${type}/${page}/100`

export const INTEREST_EP = `${HOST_NAME}/${VERSION_API}/category/interest`
export const UPDATE_INTEREST_EP = id => `${HOST_NAME}/${VERSION_API}/category/interest/${id}`

export const LOAD_BANNER = `${HOST_NAME}/${VERSION_API}/banner`

export const SEARCH_EP = `${HOST_NAME}/${VERSION_API}/search`
export const CATEGORY_EP = `${HOST_NAME}/${VERSION_API}/category`
export const LEVEL_EP = `${HOST_NAME}/${VERSION_API}/level`

export const CONTACT_EP = `${HOST_NAME}/${VERSION_API}/contact`
export const VERIFY_EP = `${HOST_NAME}/${VERSION_API}/creator/verify`
export const VERIFY_IMAGE_EP = `${HOST_NAME}/${VERSION_API}/creator/imagepassport`
export const CHECK_STATUS_CREATOR_EP = `${HOST_NAME}/${VERSION_API}/creator/checkactive`
export const DASHBOARD_EP = (page, limit) => `${HOST_NAME}/${VERSION_API}/creator/dashboard/${page}/${limit}`
export const ACTIVE_EP = id => `${HOST_NAME}/${VERSION_API}/creator/active/${id}`

export const UPLOAD_NEW_COURSE_EP = `${HOST_NAME}/${VERSION_API}/product/courses`
export const UPLOAD_FILE_NEW_COURSE_EP = `${HOST_NAME}/${VERSION_API}/product/uploadVideo`

export const CATEGORY_EXAM = `${HOST_NAME}/${VERSION_API}/exam/home/`
export const PACKAGEPRODUCT = `${HOST_NAME}/${VERSION_API}/product/packagelist/`
export const SUBCATEGORY_EXAM = id => `${HOST_NAME}/${VERSION_API}/categoryexam/${id}`
export const LIST_EXAM = catSlugName => `${HOST_NAME}/${VERSION_API}/exam/list/${catSlugName}/publishedDate/1/30`
export const OVERVIEW_EXAM = id => `${HOST_NAME}/${VERSION_API}/product/${id}`
export const SUBMIT_EXAM = `${HOST_NAME}/${VERSION_API}/exam/answer`
export const QUESTIONEXAM = id => `${HOST_NAME}/${VERSION_API}/exam/question/${id}`
export const QUESTIONTESTEXAM = id => `${HOST_NAME}/${VERSION_API}/exam/questionTest/${id}`
export const ARTICLEEXAM = id => `${HOST_NAME}/${VERSION_API}/exam/article/${id}`
export const REVIEW_EX = `${HOST_NAME}/${VERSION_API}/product/review/`
export const DELETE_REVIEW_EX = id => `${HOST_NAME}/${VERSION_API}/exam/review/${id}`
export const EXTRA_SMALL_DEVICE = 'EXTRA_SMALL_DEVICE'
export const SMALL_DEVICE = 'SMALL_DEVICE'
export const MEDIUM_DEVICE = 'MEDIUM_DEVICE'
export const LARGE_DEVICE = 'LARGE_DEVICE'
export const EXTRA_LARGE_DEVICE = 'EXTRA_LARGE_DEVICE'
export const SCHOOL_LIST = id => `${HOST_NAME}/${VERSION_API}/school/province/${id}`
export const PROVINCE_LIST = `${HOST_NAME}/${VERSION_API}/school/province/`
export const GET_COIN = `${HOST_NAME}/${VERSION_API}/coin/`
export const BUY_COIN = `${HOST_NAME}/${VERSION_API}/payForU/buyCoin`
export const REGISTER_NEWLOGIN = `${HOST_NAME}/${VERSION_API}/register/newlogin`
export const MERGE_NEWLOGIN = `${HOST_NAME}/${VERSION_API}/register/merge`
export const ETESTING_HISTORY = `${HOST_NAME}/${VERSION_API}/exam/history`
export const ETESTING_PRODUCT_HISTORY = id => `${HOST_NAME}/${VERSION_API}/exam/history/${id}`
export const HISTORY_TESTEXAM = id => `${HOST_NAME}/${VERSION_API}/exam/historyExamTest/${id}`
export const LIVE_PAGE = (startDate, EndDate) => `${HOST_NAME}/${VERSION_API}/livestream/schedule/${startDate}/${EndDate}`
export const LIVE_DETAIL = `${HOST_NAME}/${VERSION_API}/livestream/isbuy`
export const LIVE_REPLAY = (tutorId, categoryId) => `${HOST_NAME}/${VERSION_API}/livestream/replay/${tutorId}/${categoryId}`
export const LIVE_NOW = (tutorId, categoryId) => `${HOST_NAME}/${VERSION_API}/livestream/livenow/${tutorId}/${categoryId}`
export const LIVE_COMING = (tutorId, categoryId) => `${HOST_NAME}/${VERSION_API}/livestream/coming/${tutorId}/${categoryId}`
export const BANNER_ALL = `${HOST_NAME}/${VERSION_API}/banner`
export const REVIEWLIVE = (id) => `${HOST_NAME}/${VERSION_API}/product/review/${id}`

export const RESET_PASSWORD = `${HOST_NAME}/${VERSION_API}/customer/resetpasswordEmail`
// export const SCHEDULE_TIME = (startTime, endTime) => `${HOST_NAME}/${VERSION_API}/schedule/1548954000000/1551373199000`
export const SCHEDULE_TIME = (startTime, endTime) => `${HOST_NAME}/${VERSION_API}/schedule/${startTime}/${endTime}`
export const CATEGORYCREATOR = `${HOST_NAME}/${VERSION_API}/categorycreator`

export const LESSON_EP = id => `${HOST_NAME}/${VERSION_API}/course/lesson/${id}`

export const LESSON_FINISH = id => `${HOST_NAME}/${VERSION_API}/product/completemission/${id}`

export const LINE_STUDENT_REGISTER_EP = `${HOST_NAME}/${VERSION_API}/tutor/tutorcustomer`
export const LINE_STUDENT_INFO_EP = id => `${HOST_NAME}/${VERSION_API}/tutor/tutorcustomer/${id}`
export const LINE_FORM_DETAIL_EP = id => `${HOST_NAME}/${VERSION_API}/tutor/searchjob/${id}`

export const configFilter = {
  EXTRA_SMALL_DEVICE: {
    banners: 5,
    coursesNew: 5,
    coursesPopular: 5,
    coursesRecommended: 2,
    creators: 5,
    posters: 5,
    related: {
      creatorProducts: 5,
      productRecommended: 5,
      productsInCategory: 5,
    },
  },
  SMALL_DEVICE: {
    banners: 5,
    coursesNew: 5,
    coursesPopular: 5,
    coursesRecommended: 2,
    creators: 5,
    posters: 5,
    related: {
      creatorProducts: 5,
      productRecommended: 5,
      productsInCategory: 5,
    },
  },
  MEDIUM_DEVICE: {
    banners: 5,
    coursesNew: 5,
    coursesPopular: 5,
    coursesRecommended: 3,
    creators: 5,
    posters: 5,
    related: {
      creatorProducts: 5,
      productRecommended: 5,
      productsInCategory: 5,
    },
  },
  LARGE_DEVICE: {
    banners: 5,
    coursesNew: 5,
    coursesPopular: 5,
    coursesRecommended: 4,
    creators: 5,
    posters: 5,
    related: {
      creatorProducts: 5,
      productRecommended: 5,
      productsInCategory: 5,
    },
  },
  EXTRA_LARGE_DEVICE: {
    banners: 5,
    coursesNew: 5,
    coursesPopular: 5,
    coursesRecommended: 6,
    creators: 5,
    posters: 5,
    related: {
      creatorProducts: 5,
      productRecommended: 5,
      productsInCategory: 5,
    },
  },
}



// WEBPACK FOOTER //
// ./src/constant.js